import React, { useEffect, useMemo, useState } from "react";
import styles from "./LockScreenModal.module.css";
import { API_URL } from "../../config/api";

const DEFAULT_PIN = "0000";

const LockScreenModal = ({ open, onClose, seller }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);

  const token = localStorage.getItem("token");

  const masked = useMemo(() => {
    return [0, 1, 2, 3].map((i) => pin.length > i);
  }, [pin]);

  useEffect(() => {
    if (!open) return;
    setPin("");
    setError("");
  }, [open]);

  const verifyPin = async (value) => {
    const v = String(value || "").trim();

    if (v === DEFAULT_PIN) {
      onClose?.();
      return;
    }

    try {
      setChecking(true);

      const res = await fetch(`${API_URL}/api/pin/verify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify({ pin: v }),
      });

      if (res.ok) {
        onClose?.();
        return;
      }
    } catch (e) {
      // ignore
    } finally {
      setChecking(false);
    }

    setError("Неверный пин-код");
    setPin("");
  };

  const addDigit = (d) => {
    if (checking) return;
    setError("");

    setPin((prev) => {
      if (prev.length >= 4) return prev;
      const next = prev + String(d);

      if (next.length === 4) {
        setTimeout(() => verifyPin(next), 0);
      }

      return next;
    });
  };

  const backspace = () => {
    if (checking) return;
    setError("");
    setPin((prev) => prev.slice(0, -1));
  };

  const clearAll = () => {
    if (checking) return;
    setError("");
    setPin("");
  };

  const handleKey = (k) => {
    if (k === "⌫") return backspace();
    if (k === "C") return clearAll();
    if (k === ".") return;
    addDigit(k);
  };

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      {/* верхняя белая панель */}
      <div className={styles.topBar}>
        <div className={styles.brandLeft}>
          <div className={styles.brandLogo}>GM</div>

          <div>
            <div className={styles.brandTitle}>Демо Розница</div>
            <div className={styles.brandSub}>
              {seller ? `${seller}, ` : ""}Администратор
            </div>
          </div>
        </div>

        <div />
      </div>

      {/* центр */}
      <div className={styles.content}>
        <div className={styles.centerWrap}>
          <div className={styles.centerBlock}>
            <div className={styles.dotsRow}>
              {masked.map((filled, idx) => (
                <div
                  key={idx}
                  className={`${styles.dot} ${filled ? styles.dotFilled : ""}`}
                />
              ))}
            </div>

            <div className={styles.hint}>
              Пин-код по умолчанию {DEFAULT_PIN}
            </div>

            {error && <div className={styles.error}>{error}</div>}
          </div>
        </div>

        {/* зелёная зона клавиатуры */}
        <div className={styles.keypadZone}>
          <div className={styles.keypad}>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, ".", 0, "⌫"].map((k) => {
              const isDot = k === ".";
              return (
                <button
                  key={k}
                  onClick={() => handleKey(k)}
                  disabled={checking}
                  className={`${styles.key} ${isDot ? styles.keyDisabledDot : ""}`}
                  style={isDot ? undefined : undefined}
                >
                  {k === "⌫" ? "⌫" : k}
                </button>
              );
            })}

            <button
              onClick={clearAll}
              disabled={checking}
              className={styles.resetBtn}
            >
              Сброс
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockScreenModal;
